//#region imports
import React from 'react';
import cn from 'classnames';
import { OPERATORS } from 'configs/constants';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

import styles from './styles';
//#endregion

interface IProps {
  className?: string;
  currentNumber: number;
  onChangeNumber: (value: number) => void;
}

const OperatorTabPanel: React.FC<IProps> = ({ className, onChangeNumber, currentNumber }) => {
  const classes = styles();

  return (
    <Container className={ cn(className, classes.root) } >
      <Box className={ classes.tabs } >
        { OPERATORS.map(({ key, component: OperatorIcon }, index) => (
          <ButtonBase onClick={ () => onChangeNumber(index) } key={ key } className={ cn(classes.tab, { 'active': index === currentNumber }) }>
            <OperatorIcon />
          </ButtonBase>
        )) }
      </Box>
    </Container>
  );
};

export default OperatorTabPanel;
